import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserSearchItem } from '@degreed/lxp/services/user';

/**
 * This component is used to display a list of authors, typically within a DataTable column
 */

@Component({
  selector: 'dgx-authors-list',
  templateUrl: './authors-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthorsListComponent {
  @Input() public authored: UserSearchItem[];
}
